import { useMutation } from "@apollo/client/react";import { Grid } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { RenderInputByTypeMobile } from "../../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { useVisita } from "../../../../../../context/VisitaContext";
import { useStepSave } from "../../../../hooks/useStepSave";
import { filterVisitaData, getInputNames } from "../../../../utils/formDataHelper";
import CardBox from "../../CardBox/CardBox";
import SAVE_VISITA_EVOLUCION_PACIENTE, { adaptSaveVisitaEvolucionPaciente } from "../../../../../../data/graphQL/mutations/Visitas/saveVisitaEvolucionPaciente";

import { validateStepFields } from "../../../../utils/visitaStepValidation";

export default function EvolucionPaciente({ readOnly, onSaveRef, onExposeFormatted, esVisitaCero, esUrgencia }) {
  const [formData, setFormData] = useState({});

  const { visita, setVisita } = useVisita();

  const [save] = useMutation(SAVE_VISITA_EVOLUCION_PACIENTE);

  const formattedInputs = useMemo(() => {
    return inputs.map((input) => {
      const newInput = { ...input };
      if (readOnly) newInput.disabled = true;
      if (esVisitaCero || esUrgencia) newInput.required = false;
      
      return newInput;
    });
  }, [readOnly, esVisitaCero, esUrgencia]);
  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useStepSave(onSaveRef, async (validate) => {
    if (validate) validateStepFields({ formattedInputs, formData });

    const { data } = await save({ variables: adaptSaveVisitaEvolucionPaciente(formData) });
    const idVisita = data?.saveVisitaEvolucionPaciente?.idVisita;
    if (!idVisita) throw new Error("Error al guardar");
    setVisita((prev) => ({ ...prev, ...formData }));
  });

  useEffect(() => {
    if (visita) {
      const inputNames = getInputNames(inputs);
      setFormData({
        ...filterVisitaData(visita, inputNames),
        idVisita: visita.idVisita
      });
    }
  }, [visita]);

  useEffect(() => {
    onExposeFormatted?.({
      stepId: "evolucionPaciente",
      stepName: "Evolución paciente",
      formattedInputs
    });
  }, [onExposeFormatted, formattedInputs]);

  return (
    <>
            <CardBox>
                <Grid container spacing={2}>
                    {formattedInputs.
          filter((input) => !input.hidden).
          map((input) =>
          <Grid size={{ xs: 12 }} key={input.name}>
                                <RenderInputByTypeMobile
              input={input}
              value={formData[input.name]}
              handleChange={handleChange} />
            
                            </Grid>
          )}
                </Grid>
            </CardBox>
        </>);

}

const inputs = [
{
  name: "evolucion",
  displayName: "Evolución",
  type: "long_string",
  required: true,
  longStringRows: 9
}];